






































































































import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
/* component */
import PageTitle from '@/app/components/Common/PageTitle.vue'

@Component({
  components: {
    PageTitle
  }
})
export default class RiskSearch extends Vue {
  private search: string = this.$store.state.varietyState.searchText

  @Prop() private count!: number

  private doVarietySearch () {
    this.$store.commit('varietyState/setSearchText', this.search)
    this.$emit('search-list')
  }

  private doClear () {
    this.search = ''
    this.$store.commit('varietyState/setSearchText', '')
    this.$emit('reset-list')
  }
}
